import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

// ページビューのトラッキング用
const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Google Analytics のページビューを送信
    trackPageView(location.pathname + location.search);
  }, [location]);
};

export default usePageTracking;
